import { styled } from '@nykaa/ui-components';

import Image from 'shared/components/ImageV2';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${({ theme }) => theme.spacing.spacing40};
  margin: ${({ theme }) => `${theme.spacing.spacing40} 0`};
`;

export const Card = styled.button`
  display: flex;
  min-width: 0;
  align-items: flex-start;
  border: 0;
  border-radius: ${({ theme }) => theme.borders.radius20};
  background: ${({ theme }) => theme.colors.policyCardBg};
  padding: ${({ theme }) => theme.spacing.spacing40};
  text-align: left;

  &:last-child:nth-child(odd) {
    grid-column: 1 / -1;
  }
`;

export const PolicyIcon = styled(Image)`
  width: ${({ theme }) => theme.spacing.spacing120};
  height: ${({ theme }) => theme.spacing.spacing120};
  flex: 0 0 ${({ theme }) => theme.spacing.spacing120};
`;

export const CardContent = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-left: ${({ theme }) => theme.spacing.spacing40};
  font-weight: 500;
`;

export const ChevronWrapper = styled.span`
  display: inline-flex;
  margin-left: auto;
  color: ${({ theme }) => theme.colors.textPrimary};
`;
